// api接口
export const urlMaps = {
  exchangeGetBalanceApi: 'wap/buyer/exchange/getBalance', //兑换券请求
  shipperComponeyApi: 'wap/buyer/shipper/list', // 物流公司获取
  shipperSubmitApi: 'wap/buyer/shipper/submit', // 物流填写提交
  getExchangeVoucherApi: 'wap/buyer/exchange/voucher', //获取积分兑换
  getCouponDialogApi: 'wap/buyer/autoLottery', // 获取优惠券弹框
  confirmNotifyApi: 'wap/buyer/confirmNotify', //首页弹框提示确认
  userInfoApi: 'wap/buyer/userInformation', //用户信息
  groupGoodsDeatilApi: 'wap/buyer/group/groupGoods', //超级团商品详情
  groupOrderDetailApi: 'wap/buyer/group/groupOrderDetail', //超级团商品详情
  shareApi: 'wap/buyer/share',
  wxInitConfigApi: 'wap/buyer/wxInitConfig', //获取appid
  createLinkApi: 'wap/buyer/createLink', //分享创建链接
  canJoinListApi: 'wap/buyer/group/canJoinList', //获取团购商品可以加入团的列表做分页懒加载
  getCityApi: 'wap/buyer/homeAreaEdit', //获取地区城市列表
  saveAdressApi: 'wap/buyer/addHomeArea', //保存地址
  goodsCartListApi: 'wap/buyer/goodsCartList', //购物车
  changeAddressApi: 'wap/buyer/changeConfirmOrderAddress', //选择地址
  addGoodsCartApi: 'wap/buyer/addGoodsCart', //加减购物车
  goodsChooseApi: 'wap/buyer/choose', //购物车选择
  delGoodsCartApi: 'wap/buyer/delGoodsCart', //删除商品
  goodsCartCountApi: 'wap/buyer/goodsCartCount', //购物车数量
  voucherDetailApi: 'wap/buyer/exchange/getVoucherDetail', //凭证详情
  goodsListApi: 'wap/buyer/exchange/goodsList', //商品列表
  goodsDetailApi: 'wap/buyer/exchange/goodsDetail', //商品详情
  getExchangeList: 'wap/buyer/exchange/activity', //获取积分活动列表
  telephoneBindApi: 'wap/buyer/telephoneBind', //短信验证码
  userAuthApi: 'wap/userAuth', //登录认证 用户认证
  userInformationApi: 'wap/buyer/userInformation', //判断是否登录
  getConfig: 'wap/buyer/config', //获取站点配置
  getGoods: 'wap/buyer/getGoods', //获取商品信息
  getCompareAttr: 'wap/buyer/getCompareAttr', // 获取商品对比属性
  confirmOrder: 'wap/buyer/confirmOrder', //订单结算页
  holdOrder: 'wap/buyer/holdOrder', //下单
  deliveryType: 'wap/buyer/deliveryType', //地址编辑是否显示快递配 同城配
  recommendGoodsApi: 'wap/buyer/recommendGoods', //推荐商品
  chooseGoodsVoucherApi: 'wap/buyer/chooseGoodsVoucher', //优惠券接口
  changeAddressTypeApi: 'wap/buyer/changeAddressType', //切换自提配送
  TopClass: 'wap/buyer/topClass', //获取顶部分类信息
  getGoodsApi: 'wap/buyer/getGoods', //商品详情
  goodsFromClass: 'wap/buyer/goodsFromClass', //获取分类商品
  getOrderPayInformationApi: 'wap/buyer/orderPayInformation', // 选择支付方式 确认按钮点击
  getChooseCreditTypeApi: 'wap/buyer/chooseCreditType', // 选择授信类型
  payWechatApi: 'wap/buyer/miniPayByOrderId', // 微信支付
  payIntegralApi: 'wap/buyer/integralPay', // 积分支付
  payHxyktApi: 'wap/buyer/hxCreditPay', //海峡一卡通支付
  payCustomerApi: 'wap/buyer/customerPay', //客户支付渠道
  paycustomerPayApi: 'cashier/buyer/customerPay', //
  paycustomerPayInfoApi: 'cashier/buyer/customerPayInfo', //
  bindEmpNoApi: 'wap/buyer/bindEmpNo', // 绑定企业用户
  getSpecificationsApi: 'wap/buyer/getSpecifications', // 商品规格查询
  changeDifferentGoodsApi: 'wap/buyer/changeDifferentGoods', // 商品规格更改
  sendCodeApi: 'wap/buyer/sendCode', // 授信短信验证码
  validateCodeApi: 'wap/buyer/validateCode', // 校验短信验证码
  telephoneCodeApi: 'wap/buyer/phone/code', // 登录校验短信验证码
  setUpCreditPwdApi: 'wap/buyer/setUpCreditPwd', // 设置授信支付密码
  customerPayConfirmApi: 'wap/buyer/customerPayConfirm', //客户渠道支付确认
  cashiercustomerPayConfirmApi: 'cashier/buyer/customerPayConfirm', //
  ctestCreatePayConfirmApi: 'cashier/buyer/testCreate', //
  payCreditApi: 'wap/buyer/userCreditPay', // 授信支付
  orderGroupApi: 'wap/buyer/group/holdOrder', // 拼团提交订单
  signatureImageUploadApi: 'wap/buyer/signatureImageUpload', // 手写签名上传图片
  menuConfigApi: 'wap/buyer/index1', //购物车底部图片文字自由配置或首页信息
  fjghPayConfirmApi: 'wap/proxy/fjghPayConfirm', // 福建工行支付
  goodsMarkOrderApi: 'wap/buyer/goodsMakeOrder', // 去凑单信息
  goodsMakeClassApi: 'wap/buyer/goodsMakeClass', // 凑单页面分类过滤
  getVoucherUsageApi: 'wap/buyer/getVoucherUsage', // 通过id获取某个优惠券的信息
  afterSalesApi: 'wap/buyer/aftersales/orderList', // 售后
  afterSalesOrderDetailApi: 'wap/buyer/aftersales/orderDetail', // 售后详情
  applyAfterSalesApi: 'wap/buyer/aftersales/applycheck', // 申请售后
  aftersalesCancelApplyApi: 'wap/buyer/aftersales/cancelApply', //取消申请
  telephoneChangeAllowCheckApi: 'wap/buyer/telephoneChangeAllowCheck', // 设置获取手机号
  telephoneChangeApi: 'wap/buyer/telephoneChange', // 更换手机号
  orderDetailApi: 'wap/buyer/orderDetail', //订单详情
  cancelOrderApi: 'wap/buyer/cancelOrder', //取消订单
  buyAgainApi: 'wap/buyer/buyAgain', //再次购买
  getSearchApi: 'wap/buyer/search', // 首页搜索
  confirmReceiptApi: 'wap/buyer/confirmReceipt', // 确认收获
  payByOrderIdApi: 'wap/buyer/payByOrderId', // h5获取微信支付参数
  secondaryPageApi: 'wap/buyer/secondPage', // 二级页面信息
  secondaryPageApi2: '/wap/buyer/getLabelGoods', // 二级页面信息
  secondaryPageClassApi: '/wap/buyer/linkedClass/topClass', // 二级页面获取分类数据信息
  secondaryPageClassDataApi: '/wap/buyer/linkedClass/goods', // 二级页面获取分类关联的商品数据
  componentNextApi: 'wap/buyer/component/next', // 组件详细信息
  uploadImgApi: 'wap/upload/image', // h5上传图片
  feedbackApi: 'wap/buyer/user/option/feedback', // 意见反馈提交
  getUserJsdAddressApi: 'wap/buyer/getUserJsdAddress', // 获取地址列表
  changeJsdAddressApi: 'wap/buyer/changeJsdAddress', // 切换地址列表
  customerOnlineApi: 'wap/buyer/online/customer', // 获取vip电话和客服
  goodDetailChangeAddressApi: 'wap/buyer/changeAddress', // 商品详情切换地址
  topClassApi: 'wap/buyer/topClass', //获取顶部分类信息
  jsdTopClassApi: 'wap/buyer/jsdTopClass', //获取顶部分类信息
  obtainAdvertApi: 'wap/buyer/obtainAdvert', // 获取广告弹框
  indexNextApi: 'wap/buyer/page/next', //首页分页信息
  changeSiteApi: 'wap/buyer/changeSite', // 切换自提点
  obtainInfoApi: 'wap/obtainInfo', //积分商城扫描二维码获取信息
  obtainLinkInfoApi: 'wap/link/info', //获取链接信息
  simpleInfoApi: 'wap/buyer/simpleInfo', //用户信息
  trackingLogisticsPackageApi: 'wap/buyer/user/trackingLogisticsPackage', //我的物流
  trackingLogisticsApi: 'wap/buyer/trackingLogisticsPackage', //物流
  myGroupOrderApi: 'wap/buyer/group/myGroupOrder', //我的团购
  customerPayListApi: 'cashier/buyer/customerPayList', //获取顶部分类信息
  loginKeyBindApi: 'wap/buyer/loginKeyBind', //微信用户一键登录
  homeAreaListApi: 'wap/buyer/homeAreaList', //地址列表
  homeAreaDelApi: 'wap/buyer/homeAreaDel', //删除地址
  getAuthApi: 'wap/auth', // 微信认证
  userSiteApi: 'wap/buyer/userSite', //站点列表数据
  orderListApi: 'wap/buyer/orderList', //订单列表
  orderUrgeApi: 'wap/buyer/orderUrge', //催发货
  creditApi: '/wap/buyer/myCredit', // 授信信息
  customerRechargeApi: '/wap/buyer/customerRecharge', // 授信额度转换
  creditDetailApi: '/wap/buyer/creditDetail', // 授信收支明细
  afterSaleProgressApi: '/wap/buyer/aftersales/progress', // 授信收支明细
  aftersalesApplyListApi: 'wap/buyer/aftersales/toApplyList', // 申请售后
  aftersalesConfirmApi: '/wap/buyer/aftersales/confirmApply', //提交申请退货接口
  orderPayStatusApi: '/wap/buyer/queryOrderPayStatus', // 获取支付状态
  getOrderGoodsCommentOneList: '/wap/buyer/orderGoodsCommentOneList', // 获取单订单商品评价列表
  orderGoodsCommentOneSubmit: '/wap/buyer/orderGoodsCommentOneSubmit', // 商品评价单个修改
  orderGoodsCommentGoodsList: '/wap/buyer/orderGoodsCommentGoodsDetail', // 获取需要评价订单商品列表-详情
  orderGoodsCommentListSubmit: '/wap/buyer/orderGoodsCommentListSubmit', // 商品评价批量提交
  orderGoodsCommentGoodsSum: '/wap/buyer/orderGoodsCommentGoodsSum', // 获取商品各类评价总数
  orderGoodsCommentList: '/wap/buyer/orderGoodsCommentList', // 获取商品的所有评论
  indexBannerAndVajra: '/wap/buyer/pc/index', // 首页轮播图以及金刚位数据
  indexMSGoods: '/wap/buyer/pc/msGood', // 秒杀商品
  indexNewGoods: '/wap/buyer/pc/newGood', // 新品
}
